import { useI18n } from '@/contexts/i18n-hook';

interface CreditoDesenvolvedorProps {
  /** 'claro' para fundo escuro (painel de marca), 'escuro' para fundo branco. */
  variante?: 'claro' | 'escuro';
  className?: string;
}

const NOME_COMPLETO = 'Luiz Otávio Antunes Gonçalves';

/**
 * Crédito de autoria. A sigla fica visível e o nome completo aparece ao passar o
 * mouse — e também ao focar pelo teclado, por isso é um <button> e não um <span>:
 * tooltip que só responde a hover é inacessível para quem navega por teclado.
 */
export function CreditoDesenvolvedor({ variante = 'escuro', className = '' }: CreditoDesenvolvedorProps) {
  const { t } = useI18n();
  const claro = variante === 'claro';

  return (
    <div className={`group relative inline-flex items-center gap-1.5 ${className}`}>
      <span className={`text-xs ${claro ? 'text-white/45' : 'text-schmersal-gray-medium'}`}>
        {t('auth.credito.desenvolvidoPor')}
      </span>

      <button
        type="button"
        aria-label={t('auth.credito.aria', { nome: NOME_COMPLETO })}
        className={[
          'rounded text-xs font-semibold tracking-[0.14em] transition-colors',
          'focus:outline-none focus-visible:ring-2 focus-visible:ring-schmersal-turquoise/60 focus-visible:ring-offset-2',
          claro
            ? 'text-white/70 hover:text-schmersal-turquoise focus-visible:ring-offset-schmersal-blue-dark'
            : 'text-schmersal-blue hover:text-schmersal-turquoise focus-visible:ring-offset-white',
        ].join(' ')}
      >
        LOG
      </button>

      {/* Tooltip: some por padrão, aparece no hover do grupo e no foco do botão */}
      <span
        role="tooltip"
        className={[
          'pointer-events-none absolute bottom-full left-1/2 z-20 mb-2 -translate-x-1/2',
          'whitespace-nowrap rounded-md bg-schmersal-gray-darkest px-3 py-1.5',
          'text-xs font-medium text-white shadow-lg',
          'opacity-0 transition-opacity duration-150',
          'group-hover:opacity-100 group-focus-within:opacity-100',
        ].join(' ')}
      >
        {NOME_COMPLETO}
        <span
          aria-hidden="true"
          className="absolute left-1/2 top-full h-2 w-2 -translate-x-1/2 -translate-y-1 rotate-45 bg-schmersal-gray-darkest"
        />
      </span>
    </div>
  );
}
